/* Barre véhicule AutoStock Pro — v3 (bannière « véhicule identifié »)
   - Sélection marque / modèle / motorisation.
   - Mémorise le véhicule actif (localStorage) et le ré-affiche à chaque page.
   - Applique le véhicule comme filtre Shopify (?filter.p.m.asp.*) sur les collections.

   02/09/2026 — RGPD : la recherche par plaque a été retirée. Elle transmettait
   l'immatriculation dans le chemin d'une URL appelée en fetch (donc dans les logs du
   service appelé) et, en cas d'échec du JavaScript, dans l'URL de la page elle-même.
   Toute plaque déjà mémorisée dans le navigateur d'un visiteur est purgée au chargement.
*/
(function () {
  var KEY = 'asp:vehicle';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      // Purge des plaques mémorisées par la version précédente du script.
      if (v && v.plate) { delete v.plate; localStorage.setItem(KEY, JSON.stringify(v)); }
      return v;
    } catch (e) { return null; }
  }
  function write(v) { localStorage.setItem(KEY, JSON.stringify(v)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function fullTitle(v) {
    return v.title || ['Pièces détachées', v.brand, v.model, v.engine].filter(Boolean).join(' ');
  }
  function metaLine(v) {
    return [v.power_label, v.fuel, v.years_label || v.year, v.engine_code ? ('Code moteur ' + v.engine_code) : '']
      .filter(Boolean).join(' · ');
  }

  var CAR_SVG = '<svg viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
    + '<path d="M8 44c0-3 2-5 5-5h4l7-13c1.4-2.6 4.1-4.2 7-4.2h28c2.6 0 5 1.3 6.5 3.4L80 39h22c4.4 0 8 3.6 8 8 0 1.7-1.3 3-3 3h-9" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<path d="M8 44h78" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/>'
    + '<circle cx="34" cy="47" r="8" fill="#fff" stroke="currentColor" stroke-width="3.2"/>'
    + '<circle cx="88" cy="47" r="8" fill="#fff" stroke="currentColor" stroke-width="3.2"/></svg>';

  function bannerHTML(v) {
    var thumb = v.image
      ? '<img src="' + esc(v.image) + '" alt="" loading="lazy">'
      : CAR_SVG;
    var rows = [
      ['Marque', v.brand], ['Modèle', v.model], ['Motorisation', v.engine],
      ['Puissance', v.power_label], ['Énergie', v.fuel],
      ['Années', v.years_label || v.year], ['Code moteur', v.engine_code]
    ].filter(function (r) { return r[1]; })
      .map(function (r) { return '<div class="kv"><span class="k">' + esc(r[0]) + '</span><span class="v">' + esc(r[1]) + '</span></div>'; })
      .join('');

    return ''
      + '<div class="asp-vehicle__bar">'
      + '  <div class="asp-vehicle__thumb">' + thumb + '</div>'
      + '  <div class="asp-vehicle__id">'
      + '    <h2 class="asp-vehicle__title">' + esc(fullTitle(v)) + '</h2>'
      + '    <div class="asp-vehicle__meta">' + esc(metaLine(v)) + '</div>'
      + '  </div>'
      + '  <div class="asp-vehicle__actions">'
      + '    <button class="asp-btn" type="button" data-toggle-details aria-expanded="false">Informations du véhicule</button>'
      + '    <button class="asp-btn asp-btn--primary" type="button" data-vehicle-clear>Changer de véhicule</button>'
      + '  </div>'
      + '</div>'
      + '<div class="asp-vehicle__details" data-details hidden>' + rows + '</div>';
  }

  function applyFilters(v) {
    var url = new URL(window.location.href);
    ['filter.p.m.asp.marque', 'filter.p.m.asp.modele', 'filter.p.m.asp.code_moteur'].forEach(function (k) { url.searchParams.delete(k); });
    if (v.brand) url.searchParams.append('filter.p.m.asp.marque', v.brand);
    if (v.model) url.searchParams.append('filter.p.m.asp.modele', v.model);
    if (v.engineCode || v.engine_code) url.searchParams.append('filter.p.m.asp.code_moteur', v.engineCode || v.engine_code);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  class AspVehicleBar extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('[data-plate-status]');
      this.result = this.querySelector('[data-vehicle-result]');
      this.selects = this.querySelectorAll('[data-vehicle-select]');

      var v = read();
      if (v && v.brand) this.paint(v);

      this.bindResultButtons();
      var apply = this.querySelector('[data-vehicle-apply]');
      if (apply) apply.addEventListener('click', this.onApply.bind(this));
    }

    bindResultButtons() {
      var self = this;
      this.querySelectorAll('[data-vehicle-clear]').forEach(function (b) {
        b.addEventListener('click', function () { localStorage.removeItem(KEY); window.location.href = window.location.pathname; });
      });
      var toggle = this.querySelector('[data-toggle-details]');
      if (toggle) toggle.addEventListener('click', function () {
        var d = self.querySelector('[data-details]'); if (!d) return;
        var open = d.hasAttribute('hidden');
        d.toggleAttribute('hidden', !open);
        this.setAttribute('aria-expanded', String(open));
      });
    }

    paint(v) {
      if (!this.result) return;
      this.result.innerHTML = bannerHTML(v);
      this.result.hidden = false;
      var input = this.querySelector('.asp-vehicle__in');
      if (input) input.hidden = true;              // on masque la saisie une fois le véhicule choisi
      this.bindResultButtons();
    }

    onApply() {
      var v = {};
      this.selects.forEach(function (s) { if (s.value) v[s.dataset.vehicleSelect] = s.value; });
      if (!v.brand) return;
      write(v); applyFilters(v);
    }

    say(msg) { if (this.status) { this.status.textContent = msg; this.status.hidden = !msg; } }
  }

  if (!customElements.get('asp-vehicle-bar')) customElements.define('asp-vehicle-bar', AspVehicleBar);

  // Marque les cartes compatibles avec le véhicule mémorisé
  document.addEventListener('DOMContentLoaded', function () {
    var v = read(); var code = v && (v.engine_code || v.engineCode);
    if (!code) return;
    document.querySelectorAll('[data-engine-code]').forEach(function (card) {
      if (card.dataset.engineCode.toUpperCase() === String(code).toUpperCase()) {
        var fit = card.querySelector('.asp-card__fit');
        if (fit) { fit.textContent = 'Compatible'; fit.classList.add('asp-card__fit--ok'); }
      }
    });
  });
})();
